import types from "./types";

const INITIAL_STATE = {
  isLoading: true,
  error: null
};


export default function (state = INITIAL_STATE, { type: actionType }) {
  switch (actionType) {
  case types.SESSION_REQUEST:
    return {
      ...state,
      isLoading: true
    };
  case types.SESSION_CREATE:
    return {
      ...state,
      isLoading: false
    };
  case types.SESSION_CLEAR:
    return {
      ...state,
      isLoading: false
    };    
  default:
    return state;
  }
}